module.exports = "/assets/data/0b780cc71d6128df617fee18030578ca-BA20.data.json";